import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./utils/axios";
import "./assets/iconfont/iconfont.css";
import "./assets/iconfontN/iconfont.css";
import "./assets/iconfontAI/iconfont.css";
import "./styles/index.scss";
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
